import React from "react"
import { Modal, Box, Button, Divider, Typography } from "@mui/material"
import { IJob, IJobDetail } from "../../entities/job/interface"
import { hiddenScrollbar } from "../../styles/theme"

const JobDetailModal: React.FC<{ open: boolean; onClose: () => void; jobs: IJob[] }> = ({ open, onClose, jobs }) => {
    const renderDescription = (item: IJobDetail) => {
        if (!item) {
            return null
        }
        return Object.entries(item).map(([title, value]) => {
            return (
                <Box
                    key={`${item["Job Id"]}-${title}`}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    <Box
                        display={"flex"}
                        width={"30%"}
                        alignItems={"center"}
                        justifyContent={"flex-end"}
                        paddingRight={"5%"}
                    >
                        <Typography>{`${title}: `}</Typography>
                    </Box>
                    <Box display={"flex"} width={"70%"} alignItems={"center"} justifyContent={"flex-start"}>
                        <Typography>{value}</Typography>
                    </Box>
                </Box>
            )
        })
    }
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="job-details-modal"
            aria-describedby="job-details-description"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    ...hiddenScrollbar,
                    bgcolor: "primary.main",
                    color: "white",
                    p: 4,
                    borderRadius: 2,
                    width: "90%",
                    maxWidth: 800, // Increased width
                    boxShadow: 24,
                    maxHeight: "60vh",
                    alignSelf: "center",
                }}
            >
                <Typography variant="h4" align="center" gutterBottom fontWeight={"bold"}>
                    Job Details
                </Typography>
                <Divider sx={{ mb: 3, borderColor: "white" }} />
                {jobs.map((job, index) => {
                    const JobDescriptionData: IJobDetail = {
                        "Job Id": job._id,
                        Reference: job.jobReference,
                        Client: job.billable.company,
                        Origin: job.originAddress.address,
                        Destination: job.destinationAddress.address,
                        "Job Status": job.jobStatus,
                    }
                    return (
                        <Box key={job._id} mb={3}>
                            {jobs?.length > 1 && (
                                <Typography variant="h5" fontWeight={"bold"} textAlign={"center"} gutterBottom>
                                    JOB {index + 1}
                                </Typography>
                            )}
                            {renderDescription(JobDescriptionData)}
                            {job.items.map((item, index) => {
                                return (
                                    <Box key={index} display={"flex"} flexDirection={"row"}>
                                        <Box
                                            display={"flex"}
                                            width={"30%"}
                                            alignItems={"center"}
                                            justifyContent={"flex-end"}
                                            paddingRight={"5%"}
                                        >
                                            <Typography>{`Item ${index + 1}:`}</Typography>
                                        </Box>
                                        <Box
                                            display={"flex"}
                                            width={"70%"}
                                            alignItems={"center"}
                                            justifyContent={"flex-start"}
                                        >
                                            <Typography>
                                                {item.quantity} x {item.name}
                                            </Typography>
                                        </Box>
                                    </Box>
                                )
                            })}
                            <Divider sx={{ mb: 3, mt: 3, borderColor: "white", borderStyle: "dotted" }} />
                        </Box>
                    )
                })}
                <Box mt={3} display="flex" justifyContent="center">
                    <Button variant="contained" color="secondary" onClick={onClose}>
                        Close
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default JobDetailModal
